import { atom } from 'jotai';
import type { MarketRankingType } from 'shared/src/api';

export interface MarketRankingFilterState {
  selectedMarketType: MarketRankingType | null;
  selectedCategorySno: number | null;
  selectedAgeValues: (number | null)[];
  selectedStyles: string[];
}

export const marketRankingFilterAtom = atom<MarketRankingFilterState>({
  selectedMarketType: null,
  selectedCategorySno: null,
  selectedAgeValues: [],
  selectedStyles: [],
});
